import { PlanMode, PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { HyperVFormModel } from 'wizards/models/HyperV/hyper-v-form-model';
import { BaseForVMPlanHelper } from '../bases/base-for-vm-plan-helper';

export class HyperVPlanFromStepsHelper extends BaseForVMPlanHelper {
  public static HyperVModel: HyperVFormModel = null;

  public static getUpdatedPlan(plan, model: HyperVFormModel, settings: WizardHelpersSettings): any {
    this.HyperVModel = model;
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    this.isNBF = settings.isNBF;
    this.isNBFWithHybrid = settings.isNBF && this.canHybridOnNbf(settings.agentVersion);
    const forceRemoveAppAware = !settings.isAppAwareEnabled;
    const versionForExclude = +settings.agentVersion.substring(0, 2) >= 79;
    const isCreate = settings.mode !== PlanMode.edit;
    const existExclude = this.HyperVModel.selectVirtualDisksStep.allDisks.some((disk) => !!disk?.excludes?.length);

    PlanDataFromStepsHelper.updateNewPlanByNameStep(newPlan, this.HyperVModel.planNameStep);

    if (this.isNBFWithHybrid) {
      PlanDataFromStepsHelper.updateNewPlanNBFHybridByWhereBackupStep(newPlan, this.HyperVModel.whereBackupStep, this.isUnix);
    } else PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.HyperVModel.whereBackupStep, this.isNBF || this.isUnix);

    PlanDataFromStepsHelper.updateNewPlanByVirtualAdvancedSettings(
      newPlan,
      this.HyperVModel.advancedSettingsStep,
      true,
      versionForExclude && (isCreate || existExclude),
      this.isNBF
    );

    PlanDataFromStepsHelper.updateNewPlanByClusterStep(
      newPlan,
      this.HyperVModel.clusterStep,
      settings.isClusterAbility && settings.isClusterSupported
    );

    PlanDataFromStepsHelper.updateNewPlanBySelectVirtualMachineStep(newPlan, this.HyperVModel.selectVirtualMachinesStep);
    PlanDataFromStepsHelper.updateNewPlanBySelectVirtualDisksStep(newPlan, this.HyperVModel.selectVirtualDisksStep);

    if (this.isNBF) {
      PlanDataFromStepsHelper.updateNewPlanByAppAwareStep(newPlan, this.HyperVModel.appAwareStep, forceRemoveAppAware);
      PlanDataFromStepsHelper.updateNewPlanArchiveByArchiveConsistencyStep(newPlan, this.HyperVModel.archiveConsistencyStep);
      PlanDataFromStepsHelper.updateNewNBFPlanByScheduleStep(newPlan, this.HyperVModel.scheduleStep);
      PlanDataFromStepsHelper.updateNewNBFPlanByRetentionPolicyStep(newPlan, this.HyperVModel.retentionPolicyStep, true);

      if (this.isNBFWithHybrid) {
        PlanDataFromStepsHelper.updateNewNBFPlanWithHybridByRetentionPolicyStep(newPlan, this.HyperVModel.retentionPolicyStep);
      }
    } else {
      PlanDataFromStepsHelper.updateNewPlanByRetentionPolicyStep(
        newPlan,
        this.HyperVModel.retentionPolicyStep,
        this.HyperVModel.whereBackupStep.IsHybridBackup,
        this.isUnix,
        PlanTypes.BackupHyperV
      );
      PlanDataFromStepsHelper.updateNewPlanByScheduleStep(
        newPlan,
        this.HyperVModel.scheduleStep,
        this.HyperVModel.scheduleAdvancedStep,
        this.HyperVModel.simpleScheduleStep,
        this.isUnix
      );
    }

    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStep(newPlan, this.HyperVModel.compressionEncryptionStep, this.isNBF);

    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(newPlan, this.HyperVModel.prePostActionsStep, !settings.allowPrePostActions);
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.HyperVModel.notificationStep, this.isUnix);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, false);
  }
}
